import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys',
  standalone: false,
})
export class KeysPipe implements PipeTransform {
  constructor() {}

  transform(value: any, args: 'value' | 'key'): any {
    if (value) {
      if (args === 'key') {
        return Object.keys(value);
      } else if (args === 'value') {
        return Object.values(value);
      }
    }
  }
}
